import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-gray-100 dark:border-[#283039]">
      <div className="py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex-shrink-0">
                <img src="/branding/gpt-jdp-logo.png" alt="GPT-JDP Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-lg font-bold text-gray-900 dark:text-white">GPT-JDP</span>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              <span className="font-semibold text-gray-700 dark:text-gray-300">Grupo de Producción de Trabajo de Jorge Daza Pastén.</span> Plataforma integral de inteligencia artificial para profesionales y empresas. Operada por Nexus Nova Systems SpA.
            </p>
            <a 
              href="https://gpt-jdp.com" 
              className="inline-flex items-center text-sm font-medium text-primary hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              gpt-jdp.com
              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>

          {/* Producto */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">Producto</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/pricing" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Planes y precios
                </Link>
              </li>
              <li>
                <Link to="/ai-models" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Modelos de IA
                </Link>
              </li>
              <li>
                <Link to="/chatbot-capabilities" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Capacidades
                </Link>
              </li>
              <li>
                <Link to="/roadmap" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Roadmap
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Términos de uso
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Privacidad
                </Link>
              </li>
              <li>
                <Link to="/refund" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Reembolsos
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Seguridad
                </Link>
              </li>
              <li>
                <Link to="/service-quality" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Calidad de servicio
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Soporte
                </Link>
              </li>
              <li>
                <Link to="/qr-info" className="text-sm text-gray-500 dark:text-gray-400 hover:text-primary transition-colors">
                  Información
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-100 dark:border-[#283039]">
          <div className="flex flex-col items-center gap-5">
            {/* Company Branding */}
            <div className="text-center">
              <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
                Creado por <strong className="text-primary">Nexus Nova Systems SpA</strong>
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Desde Chile para toda Latinoamérica
              </p>
            </div>

            {/* Legal Disclaimer (prudente) */}
            <div className="text-center max-w-3xl mx-auto px-4">
              <p className="text-xs text-gray-400 dark:text-gray-500 leading-relaxed">
                GPT-JDP es una plataforma operativa de inteligencia artificial de Nexus Nova Systems SpA, en fase de implementación final. Los módulos de Ciberseguridad, Legal, Contabilidad y Finanzas son de carácter <strong>informativo</strong> y <strong>no reemplazan la asesoría de un profesional certificado</strong>. La IA puede cometer errores; las respuestas deben ser revisadas por el usuario. La disponibilidad de modelos y funciones puede variar según proveedor, región y condiciones comerciales vigentes.
              </p>
            </div>

            {/* Copyright */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-2 w-full">
              <p className="text-sm text-gray-400 dark:text-gray-500">
                © {currentYear} GPT-JDP — Nexus Nova Systems SpA. Todos los derechos reservados.
              </p>
              <p className="text-xs text-gray-400 dark:text-gray-500">
                Santiago, Chile
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
